module.exports = __webpack_public_path__ + "static/img/8.5d15c20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/4/1/eng/8.png
// module id = FUY3
// module chunks = 0